module.exports = __webpack_public_path__ + "zvetseni-prsou_56_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_56_after.jpg
// module id = 1349
// module chunks = 0